export const iconFontAwesomeScienceSquareVirus = (
	<i className="fa-solid fa-square-virus"></i>
);
